var React = require('react');

function Bypassfolder (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M21 5.5h-9.328L9.464 3.293A1 1 0 0 0 8.757 3H3a1 1 0 0 0-1 1v15a1 1 0 0 0 1 1h3a1 1 0 1 1 0 2H3a3 3 0 0 1-3-3V4a3 3 0 0 1 3-3h5.757a3 3 0 0 1 2.122.879L12.5 3.5H21a3 3 0 0 1 3 3V7a1 1 0 1 1-2 0v-.5a1 1 0 0 0-1-1z","fill":"#fff","key":0}),React.createElement("path",{"d":"M23.707 12.707a1 1 0 0 0-1.414-1.414L14 19.586l-3.293-3.293a1 1 0 0 0-1.414 1.414L14 22.414l9.707-9.707z","fill":"#fff","key":1})]);
}

Bypassfolder.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Bypassfolder;

Bypassfolder.default = Bypassfolder;
